import React, { useState } from "react";
import styled from "styled-components";
import { Box } from "../Box";
import { isActive } from "../DesktopMenu/_/selectedMenuItem";
import { Flex } from "../Flex";
import { Icon } from "../Icon";
import { MenuItemLink } from "../MenuItemLink";
import { MobileMenuItem } from "../MobileMenuItem";
import { MobileMenuItemProps } from "../MobileMenuItem/MobileMenuItem";
import { MobileSubMenuHeader } from "../MobileMenuItems/_/MobileSubMenuHeader";

/* istanbul ignore next */
const Overlay = styled(Flex)<MobileMenuItemProps>`
  min-height: 100%;
  position: absolute;
  z-index: 1;
  width: 0%;
  right: 0;
  top: -14;
  overflow-x: hidden;
  ${props => props.show && "width: 100%"}
`;

const Content = styled(Flex)`
  list-style-type: none;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding-inline-start: unset;
  margin-block-start: unset;
`;

export const MobileSubmenuItem: React.FC<MobileMenuItemProps> = ({
  currentPath,
  item,
  active,
  onItemClick,
}) => {
  const [visible, setVisible] = useState<boolean>(false);
  const toggleMenu = () => {
    setVisible(prevState => !prevState);
  };
  return (
    <>
      <Flex
        as="li"
        my={3}
        minHeight={45}
        onClick={toggleMenu}
        justifyContent="space-between"
        alignItems="center"
      >
        <MenuItemLink
          to={item.url}
          onClick={onItemClick}
          fontSize={4}
          color="white"
        >
          {item.title}
        </MenuItemLink>
        <Icon icon="chevron-right" fontSize={4} color="white" />
      </Flex>
      <Overlay show={visible} bg="primary" data-testid="submenu-overlay">
        <Content as="ul">
          <MobileSubMenuHeader
            active={active}
            parentItem={item}
            toggle={toggleMenu}
            onItemClick={onItemClick}
          />
          <Box ml={4}>
            {item.subMenu?.map(i =>
              i.subMenu ? (
                <MobileSubmenuItem
                  item={i}
                  key={i.title}
                  currentPath={currentPath}
                  active={isActive(currentPath, i)}
                  onItemClick={onItemClick}
                />
              ) : (
                <MobileMenuItem
                  item={i}
                  key={i.title}
                  currentPath={currentPath}
                  active={isActive(currentPath, i)}
                  onItemClick={onItemClick}
                />
              ),
            )}
          </Box>
        </Content>
      </Overlay>
    </>
  );
};
